import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Button, Lockup } from './ui';

export function StudentShell() {
  const { user, profile, isStaff, signOut } = useAuth();
  const navigate = useNavigate();
  const initials = (profile?.full_name || user?.email || '?').split(/[\s@]+/).filter(Boolean).slice(0, 2).map((s) => s[0]!.toUpperCase()).join('');
  return (
    <>
      <a href="#main" className="skip-link">Skip to content</a>
      <header className="app-header">
        <div className="container app-header-inner">
          <Lockup size={40} />
          <nav aria-label="Primary" className="app-nav">
            {user && <NavLink to="/" end>Dashboard</NavLink>}
            <NavLink to="/courses">Course catalog</NavLink>
            {user && <NavLink to="/certificates">Certificates</NavLink>}
            {isStaff && <NavLink to="/admin">Admin</NavLink>}
          </nav>
          {user ? (
            <div className="app-account">
              <NavLink to="/account" className="row" style={{ textDecoration: 'none', color: 'var(--ink)', gap: 10 }}>
                <span className="avatar" aria-hidden="true">{initials}</span>
                <span>{profile?.full_name || user.email}</span>
              </NavLink>
              <Button variant="ghost" size="sm" onClick={async () => { await signOut(); navigate('/sign-in'); }}>Sign out</Button>
            </div>
          ) : (
            <div className="app-account">
              <NavLink to="/sign-in">Sign in</NavLink>
            </div>
          )}
        </div>
      </header>
      <main id="main">
        <Outlet />
      </main>
    </>
  );
}
